
export const TOP_NAV_HEIGHT = 50

export const DRAWER_WIDTH = 380

export const PAGE_COLUMN_MIN_WIDTH = 300

export const CONTENT_LEFT_RIGHT_PADDING = 30
export const CONTENT_TOP_BOTTOM_PADDING = 20
